module.exports = __webpack_public_path__ + "img/home.13bf3d1a.svg";